import { Model } from '@vuex-orm/core';
import STORE from '@/store/STORE';

const { name } = STORE.modules.processStages;

export default class ProcessStages extends Model {
  static entity = `${ name }`;

  static fields() {
    return {
      id: this.attr(null),
      name: this.string(''),
      unique_id: this.string(''),
      steps: this.attr([]),
    };
  }

  static methodConf = {
    http: {
      url: '/catalog/process/stages',
    },
  };
}
